import { Component, OnInit } from '@angular/core';
import { HttpService } from 'src/app/http.service';
import { GlobalService } from 'src/app/global.service';

@Component({
  selector: 'app-product-trace',
  templateUrl: './product-trace.component.html',
  styleUrls: ['./product-trace.component.scss']
})
export class ProductTraceComponent implements OnInit {

  dataSource: any;
  displayedColumns: string[] = ['id', 'name'];
  constructor(private http: HttpService, private global: GlobalService) { 
    this.global.set_master_page_title = 'Product Trace';
    this.http.getProductTraceLog().subscribe((data)=> {
      console.log(data);
      this.dataSource = data
    })
  }

  ngOnInit() {
  }

}
